export const cmvrCenterAddComponent = {
  template: `<cmvr-center-main />`,
};



// WEBPACK FOOTER //
// ./src/app/components/cmvr-center/cmvr-center-add/cmvr-center-add.component.js